module.exports = __webpack_public_path__ + "static/media/Remove-Solution.55ec09cf.svg";